import { createContext, useState} from "react";

const ReportContext = createContext();

export const ReportProvider = ({ children }) => {
    const [shareReports, setShareReports] = useState([]);
    return (
        <ReportContext.Provider value={{
            shareReports,setShareReports, 
        }}>
            {children}
        </ReportContext.Provider>
    );
};

export default ReportContext;